import { useContext, useMemo } from 'react'

import { isFunction } from 'lodash'

import { getStudentFullSection } from '../../../../utils/entities/student'
import { SearchStudentFormModalContext } from '../../../../Providers/Forms/StudentForm/SearchStudentModalProvider'
import EntitiesSelector from '../EntitiesSelector'

const StudentsSelector = ({ disabled, multiple = 'default', notFoundContent, style = {}, students = [], values, dropdownRender = null, showSearch, onChange }) => {
  const context = useContext(SearchStudentFormModalContext)

  const options = useMemo(() => students.map(student => ({
    label: `${student.lastname} ${student.firstname}`,
    value: student.id,
    tooltip: `${student.lastname} ${student.firstname} - ${getStudentFullSection(student)}`,
    entity: student
  })), [students])

  return (
    <EntitiesSelector
      disabled={disabled}
      entityOptions={options}
      multiple={multiple}
      showSearch={showSearch}
      style={style}
      values={values}
      dropdownRender={context !== undefined && isFunction(dropdownRender) ? dropdownRender(context.setFormHandler) : dropdownRender}
      notFoundContent={notFoundContent}
      onChange={onChange}
    />
  )
}

export default StudentsSelector
